import React from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import { Chart } from 'components';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	errorButton: {
		color: theme.palette.error.main
	},
	infoButton: {
		color: theme.palette.info.main
	}
}));

const DrivetestChart = (props) => {
	const { className, id, data, ...rest } = props;
	const dispatch = useDispatch();
	const classes = useStyles();

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			{/* Color #1565c0 */}
			<Chart
				id={id}
				type="bar"
				data={(data && data.datasets) || []}
				dataLabels={(data && data.labels) || []}
				options={{
					title: {
						display: true,
						text: 'KPI (%)',
						fontSize: 20
					},
					legend: {
						display: true,
						position: 'right'
					},
					scales: {
						yAxes: [{
							ticks: {
								beginAtZero: true,
								min: 0,
								max: 100,
								stepSize: 20,
							}
						}]
					}
				}}
			/>
		</div>
	);
};

DrivetestChart.propTypes = {
	className: PropTypes.string,
	id: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default DrivetestChart;
